import { render } from "./FilterDetailContentBox.vue?vue&type=template&id=5cba8105&scoped=true"
import script from "./FilterDetailContentBox.vue?vue&type=script&lang=js"
export * from "./FilterDetailContentBox.vue?vue&type=script&lang=js"

import "./FilterDetailContentBox.vue?vue&type=style&index=0&id=5cba8105&scoped=true&lang=css"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cba8105"]])

export default __exports__